// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__wR-m8","active":"Navbar_active__J3ndw","link":"Navbar_link__fJJ8I"};